import getCreateText from "src/helpers/text/getCreateText"
import getSaveText from "src/helpers/text/getSaveText"

export default ({
  id,
  dirty,
  submitHandler,
  resetHandler,
  invalid,
  pending,
  modelName,
  openConfirmationModal,
  disableSubmit,
}) => {
  const isNew = Boolean(id === `new`)
  return {
    buttonConf: [
      {
        text: isNew
          ? getCreateText(pending, dirty)
          : getSaveText(pending, dirty),
        onClick: submitHandler,
        isOk: true,
        done: !dirty,
        disabled: (!isNew && (!dirty || !!invalid)) || !!pending,
      },
      {
        text: dirty ? `Отмена` : `Закрыть`,
        onClick: dirty && !disableSubmit ? openConfirmationModal : resetHandler,
        disabled: !!pending,
      },
    ],
    title: isNew
      ? getCreateText(true, dirty, modelName, true)
      : getSaveText(true, dirty, modelName, true),
    cancelHandler: resetHandler,
  }
}
